// src/Pages/ResetPassword.js
import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '../hooks/useMediaQuery'; // ADD THIS

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile(); // ADD THIS

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        setMessage('Invalid or expired reset link. Please request a new one.');
      }
    };
    checkSession();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setMessage('Passwords do not match!');
      return;
    }
    
    if (password.length < 6) {
      setMessage('Password must be at least 6 characters!');
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setMessage(error.message);
    } else {
      setMessage('✓ Password updated! Redirecting...');
      setTimeout(() => navigate('/login'), 2000);
    }
    setLoading(false);
  };

  return (
    <div style={getContainerStyle(isMobile)}>
      <div style={getContentStyle(isMobile)}>
        <h1 style={getTitleStyle(isMobile)}>Reset Password</h1>
        <p style={getSubtitleStyle(isMobile)}>Enter your new password</p>

        <form onSubmit={handleSubmit} style={getFormStyle(isMobile)}>
          <input
            type="password"
            placeholder="New password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            style={getInputStyle(isMobile)}
          />
          
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
            style={getInputStyle(isMobile)}
          />

          <button 
            type="submit" 
            disabled={loading}
            style={loading ? {...getButtonStyle(isMobile), ...buttonDisabledStyle} : getButtonStyle(isMobile)}
          >
            {loading ? 'Updating...' : 'Reset Password'}
          </button>
        </form>

        {message && (
          <div style={message.includes('✓') ? successMessageStyle : errorMessageStyle}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
}

// Dynamic style functions
const getContainerStyle = (isMobile) => ({
  minHeight: '100vh',
  background: '#1a1b1e',
  display: 'flex',
  flexDirection: 'column',
  padding: isMobile ? '16px' : '20px',
});

const getContentStyle = (isMobile) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: '400px',
  width: '100%',
  margin: '0 auto',
  paddingTop: isMobile ? '40px' : '0',
});

const getTitleStyle = (isMobile) => ({
  color: '#fff',
  fontSize: isMobile ? '28px' : '24px',
  fontWeight: 'bold',
  margin: '0 0 12px 0',
  textAlign: 'center',
});

const getSubtitleStyle = (isMobile) => ({
  color: '#b5bac1',
  fontSize: isMobile ? '15px' : '14px',
  margin: '0 0 30px 0',
  textAlign: 'center',
  lineHeight: '1.5',
});

const getFormStyle = (isMobile) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: isMobile ? '16px' : '20px',
  width: '100%',
});

const getInputStyle = (isMobile) => ({
  padding: isMobile ? '16px' : '12px 16px',
  borderRadius: '12px',
  border: 'none',
  background: '#1e1f22',
  color: '#fff',
  fontSize: '16px', // Prevents iOS zoom
  outline: 'none',
  minHeight: '48px', // Touch target
  width: '100%',
  boxSizing: 'border-box',
});

const getButtonStyle = (isMobile) => ({
  padding: isMobile ? '16px' : '14px',
  borderRadius: '12px',
  border: 'none',
  background: '#5865f2',
  color: '#fff',
  fontSize: isMobile ? '17px' : '16px',
  fontWeight: '600',
  cursor: 'pointer',
  minHeight: '52px', // Larger touch target
  width: '100%',
  transition: 'all 0.2s',
});

const buttonDisabledStyle = {
  opacity: 0.5,
  cursor: 'not-allowed',
};

const successMessageStyle = {
  marginTop: '20px',
  padding: '14px',
  borderRadius: '10px',
  background: 'rgba(35, 165, 90, 0.1)',
  color: '#23a55a',
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '1.5',
};

const errorMessageStyle = {
  marginTop: '20px',
  padding: '14px',
  borderRadius: '10px',
  background: 'rgba(242, 63, 66, 0.1)',
  color: '#f23f42',
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '1.5',
};